import React from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import './CreatorQuotes.css'

const CreatorQuotes = (props) => {
    return(
        <div className={`creator_quotes-container theme-${props.color}`}>
            <div className="base-grid">
                <h4 className="kelly-green align-center">From the source</h4>
                {
                    props.quotes.map((item, index) => {
                        let image = getImage(item.avatar);
                        return(
                            <div className="quote-wrapper" key={`quote-${index}`}>
                                <div className="f-dir-col f-justify-center quote">
                                    <p dangerouslySetInnerHTML={{ __html: item.quote }}/>
                                    <a href={`https://linktr.ee/${item.link}`}>linktr.ee/<span>{item.link}</span></a>
                                </div>
                                <div className="f-dir-col f-align-center f-justify-center quote-author">
                                    <div className="avatar-wrapper">
                                        <GatsbyImage image={image} alt={item.creator} objectFit="contain" />
                                    </div>
                                    <p className="p2 pt-10 kelly-green fw-800">{item.creator}</p>
                                    <p className="p3 kelly-green">{item.followers}</p>
                                </div>
                            </div>
                        )
                        
                    })
                }
            </div>
        </div>
    )
}

export default CreatorQuotes